export const NONE = '';
export const timeGroupUnits = ['Hour', 'Day', 'Month', 'Year'];
export const generalGroupUnits = ['Class'];
